import { putMany, removeUserRows } from "./db";
import type { Priority, Project, Task } from "./types";

export const BENCHMARK_USER_ID = "00000000-0000-4000-8000-000000000001";
const MAX_BENCHMARK_TASKS = 10000;

export function readBenchmarkCount(): number | null {
  const params = new URLSearchParams(window.location.search);
  const value = params.get("benchmark");
  if (!value) return null;
  const count = Number.parseInt(value, 10);
  if (!Number.isFinite(count) || count <= 0) return 1000;
  return Math.min(count, MAX_BENCHMARK_TASKS);
}

export async function seedBenchmarkData(count: number): Promise<void> {
  const created = new Date("2026-01-01T08:00:00.000Z").toISOString();
  const projects: Project[] = [
    project("bench-inbox", "Inbox", "#8f7a5c", 1, created),
    project("bench-work", "Work", "#5c7f8f", 2, created),
    project("bench-home", "Home", "#6f8f5c", 3, created),
  ];

  await Promise.all([
    removeUserRows("tasks", BENCHMARK_USER_ID),
    removeUserRows("projects", BENCHMARK_USER_ID),
  ]);

  await putMany("projects", projects);
  await putMany("tasks", buildTasks(count, projects, created));
}

function buildTasks(count: number, projects: Project[], created: string): Task[] {
  const priorities: Priority[] = ["none", "low", "medium", "high"];
  const tasks: Task[] = [];
  for (let index = 0; index < count; index += 1) {
    const day = (index % 28) + 1;
    const due_date = index % 5 === 0 ? null : `2026-06-${String(day).padStart(2, "0")}`;
    const updated = new Date(Date.parse(created) + index * 1000).toISOString();
    tasks.push({
      id: `bench-task-${String(index).padStart(5, "0")}`,
      user_id: BENCHMARK_USER_ID,
      title: `Benchmark task ${index + 1}`,
      notes: index % 3 === 0 ? "Searchable note for filter and typing benchmarks." : "",
      completed: index % 7 === 0,
      priority: priorities[index % priorities.length],
      due_date,
      project_id: projects[index % projects.length]?.id ?? null,
      position: index,
      created_at: created,
      updated_at: updated,
      deleted_at: null,
    });
  }
  return tasks;
}

function project(id: string, name: string, color: string, position: number, timestamp: string): Project {
  return {
    id,
    user_id: BENCHMARK_USER_ID,
    name,
    color,
    position,
    created_at: timestamp,
    updated_at: timestamp,
  };
}
